import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import Modal from './modal';
import type { ModalType } from './types';

type Props = {
  id: string;
  size: ModalType['size'];
  color?: ModalType['color'];
  content: React.ReactNode;
  title: React.ReactNode;
  closeOnClickOutside: boolean;
  /*
   * isResponseive 속성
   * true: Mobile에서 모달을 full 사이즈로 반응형 처리 (기본값)
   * false: PC와 Mobile에서 동일한 크기의 모달 사용
   */
  isResponsive: boolean;
  modalClose: () => void;
  modalSubmit: () => void;
};

export default function CustomModal({
  id,
  size,
  color = 'white',
  title,
  content,
  closeOnClickOutside,
  isResponsive = true,
  modalClose,
  modalSubmit,
}: Props) {
  const isDesktop = useMediaQuery({
    query: '(min-width: 481px)',
  });

  // 반응형 코드 추가
  const modalSize = isResponsive ? (isDesktop ? size : 'full') : size;
  return (
    <>
      <Modal.Overlay id={id} closeOnClickOutside={closeOnClickOutside} />
      <Modal size={modalSize} color={color}>
        <Modal.Header title={title} onClose={modalClose} />

        <Modal.Body size={modalSize}>
          <Modal.Message content={content} />
        </Modal.Body>

        <Modal.Footer
          buttonsInfo={[
            { closeButtonText: '취소', modalClose },
            { submitButtonText: '확인', modalSubmit },
          ]}
        />
      </Modal>
    </>
  );
}
